import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { branchingQueryKeys } from "~/branching/data-source/api/branching-query-options";
import type { ListBranchesResult } from "~/branching/data-source/port/branching-gateway";
import { useBranchingGateway } from "~/branching/data-source/port/branching-gateway-context";
import { DEFAULT_CACHE_TIME } from "~/constants";

type UseBranchesDataOptions = Pick<UseQueryOptions<ListBranchesResult, Error, ListBranchesResult>, "enabled">;

export function useBranchesData(systemId: string | undefined, { enabled = true }: UseBranchesDataOptions = {}) {
  const gateway = useBranchingGateway();
  return useQuery({
    queryKey: branchingQueryKeys.branches(systemId!),
    queryFn: () => gateway.listBranches(systemId!),
    enabled: enabled && !!systemId,
    staleTime: DEFAULT_CACHE_TIME,
  });
}
